export enum AllowedRoute {
  GeneralInfo = '/general-liability',
  Coverage = 'coverage-info',
  underwriter = '/underwriter-infor',
  Bind = '/bind-info',
  Dashboard = '/dashboard'
}

export enum OrderId {
  GenralInfo = 1,
  Remodeling = 2,
  PollutionLiability = 3,
  ProfessionalLiability = 4,
  ExcessLiability = 5,
  BuildersRisk = 6,
  ContractorsEquipment = 7,
  AddressChange = 8
}
